import { render } from "./Call.vue?vue&type=template&id=cb1538a8"
import script from "./Call.vue?vue&type=script&lang=js"
export * from "./Call.vue?vue&type=script&lang=js"

import "./Call.vue?vue&type=style&index=0&id=cb1538a8&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__